export default "__VITE_ASSET__C4Jkkg6O__"